<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="仓库">
						<el-select filterable v-model="searchInfo.warehouseId" style="width: 200px" placeholder="请选择" clear 
						@change="warehouseFocus">
							<el-option v-for="it in warehouseList" :key="it.id" :value="it.id" :label="it.warehouseName"></el-option>
						</el-select>
					</el-form-item>
                    <!-- <el-form-item label="库区">
						<el-select filterable v-model="searchInfo.districtId" style="width: 200px" placeholder="请选择" clear 
						@change="districtFocus">
							<el-option v-for="it in districList" :key="it.id" :value="it.id" :label="it.warehouseAreaName"></el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="库位" >
						<el-select filterable v-model="searchInfo.warehouseLocationId" style="width: 200px" placeholder="请选择" clear >
							<el-option v-for="it in locationList" :key="it.id" :value="it.id" :label="it.warehouseLocationName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="日期" >
						<el-date-picker v-model="searchInfo.date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"> 
						</el-date-picker>
							
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button  @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<!-- <el-button type="primary" @click="addCarousel">新增</el-button> -->
					<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%" border>
			
			<el-table-column  prop="warehouseName" label="仓库" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column  prop="warehouseAreaName" label="库区" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column  prop="warehouseLocationName" label="库位" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="pdtName" label="商品名称" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="pdtCode" label="商品编号" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="goodsStatusName" label="货物状态" align="center" width="120" :show-overflow-tooltip="true"
			:formatter="changeGoodsStatus"></el-table-column>
			<!-- <el-table-column  prop="batchNo" label="批次号" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column  prop="storageTime" label="入库日期" align="center" width="120" :show-overflow-tooltip="true">
			</el-table-column> -->
            <el-table-column prop="num" label="可用库存" align="center" width="100" :show-overflow-tooltip="true">
			</el-table-column>
			  <el-table-column prop="eaNum" label="可用库存EA" align="center" width="100" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="inNum" label="入库中" align="center" width="80" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="outNum" label="出库中" align="center" width="80" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="lockNum" label="冻结数" align="center" width="80" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="lockEaNum" label="冻结数EA" align="center" width="85" :show-overflow-tooltip="true">
			</el-table-column>
             <el-table-column prop="volume" label="体积(m³)" align="center" width="80" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="weight" label="重量(kg)" align="center" width="80" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="memo" label="备注" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="170" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="修改时间" align="center" width="170" :show-overflow-tooltip="true">
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" :title="poupTitle+'库位商品'" @close="addDialogClose"
			:close-on-click-modal="false" width="600px">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
                    <el-form-item label-width="120px"  label="仓库">
						<el-select filterable v-model="warehouseId" style="width: 300px" placeholder="请选择" clear 
						@change="warehouseFocus">
							<el-option v-for="it in warehouseList" :key="it.id" :value="it.id" :label="it.warehouseName"></el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label-width="120px"  label="库区">
						<el-select filterable v-model="districtId" style="width: 300px" placeholder="请选择" clear 
						@change="districtFocus">
							<el-option v-for="it in districList" :key="it.id" :value="it.id" :label="it.warehouseAreaName"></el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label-width="120px"  label="库位">
						<el-select filterable v-model="locationId" style="width: 300px" placeholder="请选择" clear 
						>
							<el-option v-for="it in locationList" :key="it.id" :value="it.id" :label="it.warehouseLocationName"></el-option>
						</el-select>
					</el-form-item>
					<!-- @keyup.enter.native="asd(scope.$index,$event)" -->
					<!-- @change="change" -->
					<el-form-item label-width="120px"  label="商品">
						<el-select  :remote-method="inputChange" 
							filterable  v-model="pdtId" remote @change="goodsClick"
							allow-create
							clearable
							placeholder="请选择" style="width:300px;">
							<div style="display: flex;justify-content: space-between;padding: 0 20px;font-size: 14px;">
							<span>  商品名称</span>
								商品编号
							</div>
								<!-- @click.native="select(scope.$index,item,index)"  -->
							<el-option
								style="width:600px;"
								v-for="(item,index) in dataList1"
								:key="index"
								:label="item.pdtCode"
								:value="item.id">
								<span style="float: left">{{ item.goodsName }}</span>
								<span style="float: right; color: #8492a6; font-size: 13px">{{ item.pdtCode }}</span>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="库位名称" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.warehouseLocationCode"
							auto-complete="off" placeholder="库位名称" />
					</el-form-item>
					<el-form-item label="库位编码" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.warehouseLocationName"
							auto-complete="off" placeholder="库位编码" />
					</el-form-item>
                   
                    <el-form-item label="最大体积" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.warehouseLocationVolume"
							auto-complete="off" placeholder="最大体积" >
                            <template slot="append">m³</template>
						</el-input>
					</el-form-item>
                    <el-form-item label="最大重量" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.warehouseLocationWeight"
							auto-complete="off" placeholder="最大重量" >
                            <template slot="append">t</template>
						</el-input>
					</el-form-item>
                     <el-form-item label="库位长宽" label-width="120px">
						<el-input type="text" style="width: 150px;" v-model="storeGoodsInfo.warehouseLocationLength"
							auto-complete="off" placeholder="库位长度" >
                            <template slot="append">m</template>
						</el-input>
						<el-input type="text" style="width: 150px;" v-model="storeGoodsInfo.warehouseLocationWidth"
							auto-complete="off" placeholder="库位宽度" >
                            <template slot="append">m</template>
						</el-input>
					</el-form-item>
					<el-form-item label="是否启用" class="redItem" label-width="120px">
						<el-switch v-model="storeGoodsInfo.status"  :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
                    <el-form-item label="备注" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.memo"
							auto-complete="off" placeholder="请输入备注" />
					</el-form-item>
                    <div style="height:20px"></div>
					<el-button type="primary" @click="submit" v-if="poupTitle=='新增'" :loading="addLoading">提交</el-button>
					<el-button type="primary" @click="submitClick" v-if="poupTitle=='编辑'" :loading="editLoading">提交</el-button>
				</el-form>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				expressList: [],
				searchInfo: {},
				sliderlist:{},
				storeGoodsInfo: {
					showStatus:true
				},
				dialogVisibleSwiper: false,
                // dialogVisibleSwipers: false
                poupTitle: '',
                addLoading: false,
                editLoading: false,
                
                warehouseId: '',
                districtId: '',
				locationId: '',
				pdtId:'', //商品
                locationList: [],
                warehouseList: [],
                districList: [],
				dataList1: [],
				stateOfGoodsList: [], //货物状态
			}
		},
		methods: {
            changeNull(row, column, cellValue) { //处理数据为null的情况
				if (cellValue) {
					return cellValue;
				} else {
					return "暂无";
				}
			},
			changeGoodsStatus(row, column, cellValue) { //处理货物状态
				if (cellValue) {
					// // return cellValue;
					// // this.stateOfGoodsList
					// let obj = {};
					// obj = this.stateOfGoodsList.find((item) => { //这里的userList就是上面遍历的数据源
					// 	return item.typeKey == cellValue; //筛选出匹配数据
					// });
					// return obj.typeName
					// goodsStatus
					return cellValue
				} else {
					if(row.goodsStatus){
						return row.goodsStatus;
					}else{
						return '暂无'
					}
				}
				
			},
			search() { //查询
				if(this.searchInfo.warehouseId&&this.searchInfo.date){
					this.page.pageNum = 1;
					this.findPmsUnit()
				}else{
					this.$message.error('仓库和日期必选');
				}
				
			},
			empty() { //清空
				this.searchInfo = {}
			},
			addDialogClose() {
				this.storeGoodsInfo = {}
			},
			// 
			//导出
			downloadFile() {
				let data = {
					// ...this.searchInfo,
					// startTime: this.timerArr ? this.timerArr[0] : "",
					// endTime: this.timerArr ? this.timerArr[1] : "",
					warehouseId: this.searchInfo.warehouseId,
					warehouseAreaId: this.searchInfo.districtId,
					warehouseLocationId: this.searchInfo.LocationId,
					pdtName: this.searchInfo.pdtName,
					pdtCode: this.searchInfo.pdtCode,
					goodsStatus: this.searchInfo.stateOfGoodsId
				};
				// console.log(data);
				this.$api.locationGoodsExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "按库位查询" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			findPmsUnit() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					warehouseId: this.searchInfo.warehouseId,
					warehouseLocationId: this.searchInfo.warehouseLocationId,
					date: this.searchInfo.date,
				}
				this.$api.getTransLogList(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

            },
            warehouseFocus(e){ //仓库选择 - 库区查询
                // this.$api.getDistrictListNoParameter({
                //     warehouseId: e,
                //     status: 1
                // }).then((res) => {
				// 	// console.log('2344--',res.data)
				// 	if (res.state == 'success') {
				// 		this.districList = res.data
				// 	}
				// })
				this.$api.getLocationListNoParameter({
                    warehouseLocationName: '',
                    warehouseId: e,
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.locationList = res.data
					}
				})
            },
            districtFocus(e){ //库区选择 - 库位查询
                this.$api.getLocationListNoParameter({
                    warehouseAreaId: e,
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.locationList = res.data
					}
				})
			},
			inputChange(e) {
				this.dataList1=[]
				this.$api.findgs(this.$encrypt({
					queryParam: e
				})).then(res => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.data.length > 0) {
						res.data.forEach((item,index)=> {
							this.dataList1.push({
								goodsName: item.pdtName,
								goodsId:item.id,
								pdtCode: item.pdtCode,
								unitName: item.unitName,
							})
						})
						// this.flag=true
					} else {
						this.dataList1 = []
					}
					// console.log('dataList1--',this.dataList1)

				})
			},
			goodsClick(e){
				// console.log('234--', e)
			},
			// 新增
			addCarousel() {
                this.storeGoodsInfo = {};
                this.poupTitle = '新增';
                this.warehouseId = '';
                this.districtId = '';
				this.dialogVisibleSwiper = true

			},

			// 提交
			submit() {
                // let data = this.storeGoodsInfo
                this.addLoading = true;
				let data = {
                    warehouseId: this.warehouseId,
                    warehouseAreaId: this.districtId,
					warehouseLocationCode: this.storeGoodsInfo.warehouseLocationCode,
                    warehouseLocationName: this.storeGoodsInfo.warehouseLocationName,
                    warehouseLocationType: this.storeGoodsInfo.warehouseLocationType,
                    useType: this.storeGoodsInfo.useType,

                    warehouseLocationVolume: this.storeGoodsInfo.warehouseLocationVolume,
                    warehouseLocationWeight: this.storeGoodsInfo.warehouseLocationWeight,
                    warehouseLocationLength: this.storeGoodsInfo.warehouseLocationLength,
                    warehouseLocationWidth: this.storeGoodsInfo.warehouseLocationWidth,

                    status: this.storeGoodsInfo.status ? 1 : 0,
                    memo: this.storeGoodsInfo.memo
				}
				// console.log(data)
				this.$api.addWarehouseLocationInfo(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.findPmsUnit()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
                    }
                    this.addLoading = false;
				})

			},

			// 编辑
			editialogVisible(e) {
                // console.log(e)
                this.storeGoodsInfo = {};
                this.warehouseId = '';
                this.districtId = '';
                this.poupTitle = '编辑';
				this.$api.getWarehouseLocationInfoByID(e).then((res) => {
					if (res.state == 'success') {
                        this.storeGoodsInfo = res.data;
                        this.warehouseId =  res.data.warehouseId;
                        this.districtId = res.data.warehouseAreaId;
                        this.storeGoodsInfo.status = res.data.status == 1 ? true : false;
                        this.warehouseFocus(res.data.warehouseId)
						this.dialogVisibleSwiper = true
				
					}
				})

			},
			// 编辑修改提交
			submitClick() {
                this.editLoading = true;
                // let data = this.storeGoodsInfo
                let data = {
					 warehouseId: this.warehouseId,
                    warehouseAreaId: this.districtId,
					warehouseLocationCode: this.storeGoodsInfo.warehouseLocationCode,
                    warehouseLocationName: this.storeGoodsInfo.warehouseLocationName,
                    warehouseLocationType: this.storeGoodsInfo.warehouseLocationType,
                    useType: this.storeGoodsInfo.useType,

                    warehouseLocationVolume: this.storeGoodsInfo.warehouseLocationVolume,
                    warehouseLocationWeight: this.storeGoodsInfo.warehouseLocationWeight,
                    warehouseLocationLength: this.storeGoodsInfo.warehouseLocationLength,
                    warehouseLocationWidth: this.storeGoodsInfo.warehouseLocationWidth,

                    status: this.storeGoodsInfo.status ? 1 : 0,
                    memo: this.storeGoodsInfo.memo,

                    id: this.storeGoodsInfo.id
				}
				this.$api.updateWarehouseLocationInfo(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwiper = false
						this.findPmsUnit();
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
                    }
                    this.editLoading = false;
				})

			},
			// 停用
			toBlockUp(e) {
				// console.log(e)
				var str = "此操作将停用该库位, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.locationDisableAndEnable(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			// 启用
			toStartUsing(e) {
				// console.log(e)
				var str = "此操作将启用该库位, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.locationDisableAndEnable(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findPmsUnit();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findPmsUnit()
            },
            getWarehouseLis(){
                this.$api.getWarehouseListNoParameter({
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.warehouseList = res.data
					}
				})
			},
			getStateOfGoodsListI(){ //货物状态查看
                this.$api.getStateOfGoodsList().then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.stateOfGoodsList = res.data
					}
				})
			},
		},
		created() {
			// this.findPmsUnit()
			this.getWarehouseLis()
			this.getStateOfGoodsListI()
		}
	}
</script>

<style>
.el-form-item__content{
	margin: 0 !important;
}
</style>
